export const getLast4CardNumbers = (cardNumber = '') => cardNumber.slice(-4);
